<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Plants</h4>
                            <!-- <p class="card-category">List of tasks</p> -->
                            <p></p>

                            

                            <div class="row mt10">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="search" class="control-label">Search</label>
                                        <!-- <select v-model="project_id" id="type-filter"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>All</option>
                                            <option value="2">Planner</option>
                                            <option value="3">Presets</option>
                                        </select> -->
                                        <input
                                            id="search"
                                            v-model="search"
                                            v-on:keyup="filter($event)"
                                            class="form-control"
                                            placeholder="Type to search"
                                            aria-describedby="addon-right addon-left">
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row mt10">
                                
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="field" class="control-label">Field</label>
                                        <v-select 
                                            id="field" 
                                            v-model="filterBox.field"  
                                            :clearable="false" 
                                            :options="fields">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="equally" class="control-label">Equally</label>
                                        <v-select id="equally" v-model="filterBox.equally"  :clearable="false" :options="filterBox.equallyValues"></v-select>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="status" class="control-label">Status</label>
                                        <v-select id="status" v-model="filterBox.status"  :clearable="false" :options="filterBox.statusValues"></v-select>
                                    </div>
                                </div>

                                <!-- <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="value" class="control-label">Value</label>
                                        <input
                                            id="value"
                                            v-model="filters.value"
                                            class="form-control string-input"
                                            aria-describedby="addon-right addon-left">
                                    </div>
                                </div> -->

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-success btn-fill "
                                            @click.prevent="get">
                                        Filter
                                        </button>

                                        <button type="submit" class="btn btn-warning btn-fill "
                                            @click.prevent="clearFilters">
                                        Clear
                                        </button>
                                    </div>
                                    
                                </div>

                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="create">
                                        Add new plant
                                    </button>
                                </div>

                            </div>


                        </template>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'id'">Id</span>
                                        <span v-else-if="column === 'index'">#</span>
                                        <span v-else-if="column === 'preview_img'">Preview img</span>
                                        <span v-else-if="column === 'c_names'">Common Names</span>
                                        <span v-else-if="column === 'botanical_name'">Botanical name</span>
                                        <span v-else-if="column === 'plant_id_req_id'">Plant.id req</span>
                                        <span v-else-if="column === 'status'">Status</span>
                                        <span v-else-if="column === 'img'">Image</span>
                                        <span v-else-if="column === 'comment'">Comment</span>
                                        <span v-else-if="column === 'edit'"></span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data" class="table-row" :class="item.status ? '' : 'not-verified-row'">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'preview_img'">
                                                <img 
                                                    v-if="item[`preview_img`]"
                                                    class="preview-img"
                                                    style="cursor:pointer;"
                                                    v-bind:src="item[`preview_img`]"
                                                    @click.prevent="() => showPlantPhoto(item.id)"
                                                    />
                                                <span 
                                                    class="text-info"
                                                    style="cursor:pointer;"
                                                    v-if="item[`preview_img`] === null"
                                                    @click.prevent="() => showPlantPhoto(item.id)">
                                                    No image</span>
                                            </span>
                                             <span v-else-if="column === 'status'">
                                                <span v-if="item.status === 0">Not verified</span>
                                                <span v-if="item.status === 1">Verified</span>
                                            </span>

                                             <span v-else-if="column === 'comment'">
                                                
                                                <span>{{ item[column] | toShortText }}</span>
                                            </span>
                                           
                                            <span v-else-if="column === 'edit'">
                                                <button type="button" class="btn btn-danger"
                                                        @click.prevent="() => showPlantInfo(item.id)">
                                                    <i class="fas fa-edit" ></i>
                                                </button>
                                            </span>
                                            <span v-else-if="column === 'created_at'">
                                                {{ item[column] | toEasyDate }}
                                            </span>
                                            <span v-else>{{item[column]}}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="pagination-row">
                            <pagination :records="count" v-model="page" :per-page="limit" @paginate="paginate"></pagination>
                        </div>
                        
                        <!-- <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            Next
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Previous
                        </div> -->

                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
    const _ = require('lodash')
    const axios = require('axios')
    import LTable from 'src/components/UIComponents/Table.vue'
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    import moment from 'moment'

    export default {
        components: {
            LTable,
            Card
        },
        created: function () {
            if (this.$route.query.page) {
                this.page = parseInt(this.$route.query.page)
                this.paginate();
            } else {
                this.get()
            }

            document.title = `Plants`;
        },
        data() {
            return {
                columns: ['index', 'id', 'preview_img', 'c_names', 'botanical_name', 'plant_id_req_id', 'comment', 'status', 'edit'],
                data: [],
                limit: 100,
                offset: 0,
                page: 1,
                count: 0,
                search: '',
                filterBox: {
                    field: null,
                    equally: {
                            label: 'None',
                            code: 'none'
                        },
                    value: '',
                    status: {
                            label: 'Verified',
                            code: 1
                    },
                    statusValues: [
                        {
                            label: 'Verified',
                            code: 1
                        },
                        {
                            label: 'Not verified',
                            code: 0
                        }
                    ],
                    equallyValues: [
                        {
                            label: 'None',
                            code: 'none'
                        },
                        {
                            label: 'Comment Yes',
                            code: 'comment_yes'
                        },
                        {
                            label: 'Comment No',
                            code: 'comment_no'
                        }
                    ]
                },
                fields: [
                    'comment',
                    'status',
                    'preview_img',
                    'botanical_name',
                    'common_names',
                    'bloom_time',
                    'flower_color',
                    'hardiness_zone',
                    'soil_type',
                    'soil_ph',
                    'soil_drainage',
                    'toxicity',
                    'name',
                    'genus',
                    'species',
                    'family_name',
                    'propagation',
                    'pest_diseases',
                    'height',
                    'plant_type',
                    'leaves',
                    'leaf_color',
                    'poisonous',
                    'photos',
                    'light',
                    'description',
                    'cultivars',
                    'spread',
                    'pruning',
                    'fertilizer',
                ]
            }
        },
        filters: {
            toEasyDate (value) {
                return moment(String(value)).format('DD.MM.YYYY, HH:mm')
            },
            toShortText (value) {
                return value && value.length > 30 ? value.substr(0, 30) + '...' : value;
            }
        },
        methods: {
            clearFilters: function () {
                this.filterBox = {
                    ...this.filterBox,
                    field: null,
                    equally: {
                            label: 'None',
                            code: 'none'
                        },
                    value: '',
                    status: {
                            label: 'Verified',
                            code: 1
                    },
                };

                this.get();
            },

            filter: function (event) {
                console.log(this.search);
                if ((this.search && this.search.length >= 1) || this.search.length === 0) {
                    this.page = 1
                    this.get();
                }
                
            },
            get: function () {
                let self = this;

                let token = localStorage.getItem('token');

                axios.get(
                    `${this.$hostname}/admin/plants`,
                    {
                        'params': {
                            ...(self.search && {search: self.search}),
                            limit: this.limit,
                            offset: this.offset,
                            ...(self.filterBox.field && {field: self.filterBox.field}),
                            ...(self.filterBox.equally && {equally: self.filterBox.equally.code}),
                            ...(self.filterBox.value && {value: self.filterBox.value.code}),
                            ...{status: self.filterBox.status.code},
                        },
                        'headers': {
                            'Authorization': token
                        }
                    })
                    .then(function (response) {
                        self.data = response.data.plants.map((p, index) => {
                                p['index'] = index +1 + self.offset ;
                                return p;
                            });

                        self.count = response.data.totalCount;

                    })
                    .catch(function (error) {
                        console.log(error)
                    })

            },
            paginate: function () {
                this.offset = (this.page - 1) * this.limit;
                // let route = this.$router.resolve({path: `/plants?page=${this.page}`});
                this.$router.push(`/plants?page=${this.page}`)
                this.get();               
            },
            prev: function () {
                if (this.offset >= this.limit) {
                    this.offset -= this.limit;
                    this.get();
                }
            },
            next: function () {
                if (this.data.length === this.limit) {
                    this.offset += this.limit;
                    this.get();
                }
            },
            saveFilters: function(name, value) {
                localStorage.setItem(name, value);
            },
            showPlantInfo: function (id) {
                let route = this.$router.resolve({path: `/plants/${id}`});
                window.open(route.href, '_blank');
            },
            showPlantPhoto: function (id) {
                let route = this.$router.resolve({path: `/plants/${id}/photo`});
                window.open(route.href, '_blank');
            },
            create: function () {            
                let self = this;
                let token = localStorage.getItem('token');

                axios.post(
                    `${this.$hostname}/admin/plants/create`,
                    {id: 1},
                    {
                        'headers': {
                            'Authorization': token
                        }
                    })
                    .then(function (response) {
                        let route = self.$router.resolve({path: `/plants/${response.data.id}`});
                        window.open(route.href, '_blank');
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        }
    }
</script>
<style scoped>
    .b {
        font-weight: 800 !important;
    }
    .pagination-button {
        height: 30px;
        padding: 1px 16px;
        margin-left: 20px;
        color: #fff !important;
    }
    .pagination-button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .text-primary {
        cursor: pointer;
    }

    .wallpapers-preview {
        cursor: pointer;
        max-height: 200px;
    }

    .mt10 {
        margin-top: 10px;
    }

    .btn-fill {
        margin-top: 25px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }

    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }
    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .device1 {
        display: block;
        width: 92px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 30px;
    }
    .device2 {
        display: block;
        width: 112px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 20px;
    }
    .device3 {
        display: block;
        width: 150px;
        height: 200px;
        border: 3px solid #000;
        border-radius: 10px;
    }
    .mt30 {
        margin-top: 30px;
    }
    .color-block {
        display: block;
        width: 50px;
        height: 50px;
    }
    .table-row {
        /* cursor: pointer; */
    }
    .string-input {
        height: 35px;
    }
    .preview-img {
        width: 100px;
        height: 100px;
        /* margin-bottom: 20px; */
    }
    .not-verified-row {
        background-color:#ff000036
    }
    td {
        max-width: 500px;
    }
    .pagination-row {
        justify-content: center;
        display: flex;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plants/Plants.vue